<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $tc("Movie", 1) }} {{ $tc("Experience", 1) }}
        </div>
      </div>
      <div>
        <router-link
          v-if="$can('create', 'Movie Experience')"
          variant="default"
          class="btn-blue"
          to="add-movie-experience"
          >{{ $tc("add") }}</router-link
        >
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:500="getMovieExperiences"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th>Movie Experience</th>
        </tr>
      </thead>
      <tbody v-if="MovieExperiences.length > 0">
        <tr v-for="(item, key) in MovieExperiences" :key="key">
          <!-- <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  item.movie_experience_is_active ? 'active' : 'inactive'
                "
              />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  v-if="$can('update', 'Movie Experience')"
                  @click="goToRoute('/master/edit-movie-experience', item)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  item.movie_experience_is_active ? 'active' : 'inactive'
                "
              />
              <div
                v-if="$can('update', 'Movie Experience')"
                class="ml-4 clickable-icon"
                @click="goToRoute('/master/edit-movie-experience', item)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </div>
            </div>
          </td>
          <td>{{ item.movie_experience }}</td>
        </tr>
      </tbody>
      <tbody v-if="MovieExperiences.length == 0">
        <td colspan="2">
          {{ errors.message }}
          <NoRecords />
        </td>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      MovieExperiences: [],
      customErrors: {
        message: "",
      },
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
      searchValue: "",
    };
  },
  beforeMount() {
    this.getMovieExperiences();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getMovieExperiences();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getMovieExperiences();
      } else {
        this.currentPage = event;
        this.getMovieExperiences();
      }
    },
    /* eslint-disable */
    goToRoute: function (path, item) {
      console.log("item :", item);
      const { movie_experience_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: movie_experience_id,
        },
      });
    },

    getMovieExperiences: function () {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        searchValue: this.searchValue,
      };
      this.MovieExperiences = [];
      MasterService.GetAllMovieExperienceFormats(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("data", data);
            if (
              data.Records &&
              data.Records.data &&
              data.Records.data.length > 0
            ) {
              this.MovieExperiences = data.Records.data;
              this.MovieExperiences.forEach((x) => {
                x.movie_experience_is_active =
                  x.movie_experience_is_active === "Y" ? true : false;
              });
              if (data.Records.pagination && data.Records.pagination.total) {
                this.rows = data.Records.pagination.total;
                this.selectedvalue =
                  data.Records.pagination.total < 10
                    ? data.Records.pagination.total
                    : this.selectedvalue;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(data.error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/MovieExperienceComponent/ListMovieExperience.vue